import * as React from "react";
import { push as BurgerMenu } from "react-burger-menu";
import { connect } from "react-redux";
import * as redux from "redux";
import * as Actions from "../../actions";
import { Paths } from "../../constants";
import Settings from "../../settings";
import { AppState } from "../../store";
import { ReactHelper } from "../../utils";
import { DefaultConnectedDispatch, DefaultConnectedState, DefaultDispatchPropsMap, DefaultStatePropsMap } from "../base";
import { Icon } from "../generic";
import { Breakpoint } from "../responsive";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...DefaultStatePropsMap(state, ownProps),
    open: state.adminMenu.open,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...DefaultDispatchPropsMap(dispatch),
    toggleOpen: (open: boolean) => dispatch(Actions.AdminMenu.toggleOpen(open)),
});

interface OwnProps {
}

type ConnectedState = DefaultConnectedState & {
    open: boolean;
};

type ConnectedDispatch = DefaultConnectedDispatch & {
    toggleOpen: (open: boolean) => void;
};

interface OwnState {
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class MenuComponent extends React.Component<CombinedProps, OwnState> {

    private AMEventId = Settings.CurrentAnnualMeetingID;

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public render() {
        return <div id="menu-wrapper">
            <BurgerMenu
                id="menu"
                isOpen={this.props.open}
                pageWrapId="page"
                outerContainerId="app-wrapper"
                customBurgerIcon={false}
                customCrossIcon={false}
                onStateChange={(state) => this.handleStateChange(state)}
            >
                <a id="menu-close" href="" title="Hide" onClick={(e) => this.onCloseClick(e)}>
                    <Icon icon="times" />
                </a>

                <div id="menu-logo">
                    <img alt={`${Settings.ClientName}`} src="/content/images/logo.png" />
                </div>

                <Breakpoint maxWidth={Settings.ResponsiveAdminBreakpointWidth}>
                    <ul>
                        <li><a href="#" onClick={(e) => this.gotoLink(e, Paths.Account.Logout)}>Sign out <Icon icon="sign-out" /></a></li>
                    </ul>
                </Breakpoint>

                <ul>
                    <li><a href={Paths.Admin.Landing} onClick={(e) => this.gotoLink(e, Paths.Admin.Landing)}>Dashboard</a></li>
                    <li><a href={Paths.AdminNav.List} onClick={(e) => this.gotoLink(e, Paths.AdminNav.List)}>Navigation</a></li>
                    <li><a href={Paths.AdminPage.List} onClick={(e) => this.gotoLink(e, Paths.AdminPage.List)}>Pages</a></li>
                    <li><a href={Paths.AdminEmailTemplate.List} onClick={(e) => this.gotoLink(e, Paths.AdminEmailTemplate.List)}>Email templates</a></li>
                    <li><a href={Paths.AdminEvent.List} onClick={(e) => this.gotoLink(e, Paths.AdminEvent.List)}>Events</a></li>
                    <li><a href={Paths.AdminAbstractList(this.AMEventId)} onClick={(e) => this.gotoLink(e, Paths.AdminAbstractList(this.AMEventId))}>Abstracts</a></li>
                    <li><a href={Paths.AdminTag.List} onClick={(e) => this.gotoLink(e, Paths.AdminTag.List)}>Tags</a></li>
                </ul>
            </BurgerMenu>
        </div>;
    }

    private onCloseClick(e: React.MouseEvent<HTMLAnchorElement>) {
        this.props.toggleOpen(false);
        return ReactHelper.emptyClick(e);
    }

    private gotoLink(e: React.MouseEvent<HTMLAnchorElement>, path: string) {
        this.props.toggleOpen(false);
        this.props.goto(path);
        return ReactHelper.emptyClick(e);
    }

    private handleStateChange(menuState: { isOpen: boolean }) {
        if (this.props.open !== menuState.isOpen)
            this.props.toggleOpen(menuState.isOpen);
    }
}

export const Menu: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/admin/Menu.tsx